import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { COOKIE_PARENT_DOMAIN } from '@/helpers/locale';
import { APP_ROUTER_BASE } from '@/config/routerBase';
import hashMap from '../locales-hash.json';

export const DEFAULT_LOCALE = 'en';
export const LOCALES = ['en', 'el', 'es', 'pt', 'de', 'nl', 'et'];

const namespaces = [
  'activity',
  'auth',
  'bank-accounts',
  'brands',
  'cash',
  'common',
  'compliance',
  'components',
  'dashboard',
  'dynamic',
  'flexibility',
  'founder-pricing',
  'founders',
  'fpg-v1',
  'fundraising',
  'kit',
  'loan-terms',
  'loans',
  'modal',
  'next-repayment',
  'plans-v5',
  'profile',
  'refinancing',
  'reporting',
  'withdraw',
];

i18n
  .use(HttpApi) // Load translations via HTTP
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind React-i18next
  .init({
    fallbackLng: DEFAULT_LOCALE, // Default language
    supportedLngs: LOCALES, // List of supported languages
    debug: false, // Enable console logs for debugging
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    ns: namespaces, // Namespaces
    defaultNS: 'common',
    backend: {
      loadPath: (lng, ns) => {
        const hash = getHashForNamespace(lng, ns);
        const isDev = import.meta.env.VITE_ENV === 'development';
        // Without a CDN the catalogues sit under the router base ('/' by default).
        const cdnUrl = isDev ? '' : import.meta.env.VITE_CDN_URL || APP_ROUTER_BASE;
        return `${cdnUrl.replace(/\/+$/, '')}/locales/${lng}/${ns}_${hash}.json`;
      },
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'], // Cache the language
      lookupCookie: 'preferredLanguage',
      cookieDomain: COOKIE_PARENT_DOMAIN, // Set domain for cookie
    },
  });

function getHashForNamespace(lng, ns) {
  return hashMap[lng] && hashMap[lng][ns] ? hashMap[lng][ns] : '';
}

export default i18n;
